import { render, staticRenderFns } from "./VerPedido.vue?vue&type=template&id=4b7f68c3&scoped=true"
import script from "./VerPedido.vue?vue&type=script&lang=js"
export * from "./VerPedido.vue?vue&type=script&lang=js"
import style0 from "./VerPedido.vue?vue&type=style&index=0&id=4b7f68c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7f68c3",
  null
  
)

export default component.exports